import { InjectionToken } from "@angular/core";

export const SetupAppService = new InjectionToken('SetupAppService');
export const UnsavedGuardService = new InjectionToken('unsavedWarningSharedService');
export const AutoSaveService = new InjectionToken('AutoSaveService');
export const EventSectionEditService = new InjectionToken('EventSectionEditService');
export const CheckService = new InjectionToken('CheckService');

export const setupAppProvider = [
    {
        provide: SetupAppService,
        useFactory: (i: any) => i.get('SetupAppService'),
        deps: ['$injector']
    },
    {
        provide: UnsavedGuardService,
        useFactory: (i: any) => i.get('unsavedWarningSharedService'),
        deps: ['$injector']
    },
    {
        provide: AutoSaveService,
        useFactory: (i: any) => i.get('AutoSaveService'),
        deps: ['$injector']
    },
    {
        provide: EventSectionEditService,
        useFactory: (i: any) => i.get('EventSectionEditService'),
        deps: ['$injector']
    },
    {
        provide: CheckService,
        useFactory: (i: any) => i.get('CheckService'),
        deps: ['$injector']
    }
];